import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AccountWallModels } from '@models/account-wall.model';

export const AccountWallActions = createActionGroup({
  source: 'Account Walls',
  events: {
    'Get All Walls': props<{ accountId: string }>(),
    'Get All Walls Success': props<{
      walls: AccountWallModels.WallWithAssignment[];
      isFirstPage: boolean;
    }>(),
    'Get All Walls Fail': emptyProps(),

    'Get Next Page': emptyProps(),

    'Set Search Query Filter': props<{ query: string | null }>(),
    'Set Camera Query Filter': props<{
      cameraIdsIncludes: string[];
    }>(),
    'Set Tags Filter': props<{ tagIds: string | null }>(),
    'Remove Camera Filter': props<{ cameraId: string }>(),
    'Remove Query Filter': emptyProps(),
    'Remove Tags Filter': emptyProps(),
    'On Query Params Changed': emptyProps(),
    'Reset Paging': emptyProps(),

    'Add Wall To Account': props<{ accountId: string; wallId: string }>(),
    'Add Wall To Account Success': props<{ wallId: string }>(),
    'Add Wall To Account Fail': emptyProps(),

    'Remove Wall From Account': props<{ accountId: string; wallId: string }>(),
    'Remove Wall From Account Success': props<{ wallId: string }>(),
    'Remove Wall From Account Fail': emptyProps(),

    'Reset State': emptyProps(),
  },
});
